import { Controller } from '@hotwired/stimulus'
import { TOAST_DURATION_MS } from '@/lib/toast-duration'

export default class extends Controller<HTMLElement> {
  static override targets = ['list', 'toast']

  declare readonly listTarget: HTMLOListElement
  declare readonly toastTargets: HTMLElement[]

  private timers = new Map<HTMLElement, number>()

  override connect() {
    const toasts = [...this.listTarget.children]
    this.listTarget.replaceChildren()
    requestAnimationFrame(() => this.listTarget.append(...toasts))
  }

  override disconnect() {
    this.pause()
  }

  toastTargetConnected(toast: HTMLElement) {
    this.schedule(toast)
  }

  toastTargetDisconnected(toast: HTMLElement) {
    window.clearTimeout(this.timers.get(toast))
    this.timers.delete(toast)
  }

  dismiss(event: Event) {
    const toast = (event.currentTarget as HTMLElement).closest<HTMLElement>('.toast')
    if (toast) this.remove(toast)
  }

  pause() {
    for (const timer of this.timers.values()) window.clearTimeout(timer)
    this.timers.clear()
  }

  resume() {
    for (const toast of this.toastTargets) this.schedule(toast)
  }

  private schedule(toast: HTMLElement) {
    window.clearTimeout(this.timers.get(toast))
    if (toast.dataset.type === 'error') return
    this.timers.set(
      toast,
      window.setTimeout(() => this.remove(toast), TOAST_DURATION_MS),
    )
  }

  private remove(toast: HTMLElement) {
    toast.remove()
    if (this.toastTargets.length === 0) this.element.remove()
  }
}
